import template from './employee_document_reject.html';
import tr from '../../lib/default-translator.js';

class EmployeeDocumentRejectViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.reason = ko.observable('');
	};

	close()
	{
		this.dialog.close(false);
	};

	async save_reject()
	{
		// Validate
		if (this.reason() == null || this.reason() == '')
		{
			Grape.alerts.alert({type: 'error', message: tr('Please give a valid reason for rejecting','Please give a valid reason for rejecting'), title: tr('Error', 'Error')});
			return;
		}

		let data = {
			employee_document_id: this.dialog.bindings.employee_document_id,
			rejection_reason: this.reason()
		};

		try {
			let res = await Grape.fetches.postJSON('/admin/reject_document', data);
			if (res.status == 'OK')
			{
				await Grape.alerts.alert({type: 'success', message: tr('Successfully deleted & rejected document.', 'Successfully deleted & rejected document.'), title: tr('Success', 'Success')});
				this.dialog.close(true);
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({ type: 'error', title: tr('Error', 'Error'), message: tr('An error occurred while rejecting the document..') });
		}
	};
}

class EmployeeDocumentRejectPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeDocumentRejectViewModel(this);
		this.bindings = bindings;
	};
};

export default {
	name: 'EmployeeDocumentReject',
	dialog_class: EmployeeDocumentRejectPage,
	template: template,
	template_filename: 'translation/dialogs/employee_document_reject',
	provider: 'ps'
};
